import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      title: "",
      rows: _ctx.devices,
      columns: _ctx.columns,
      "rows-per-page-label": _ctx.t('session.rowsperpage'),
      "row-key": "name"
    }, {
      "bottom-row": _withCtx(() => [
        _createVNode(_component_q_btn, {
          color: "grey-7",
          "icon-right": "archive",
          label: _ctx.t('tags.exporttocsv'),
          "no-caps": "",
          onClick: _ctx.exportTable
        }, null, 8, ["label", "onClick"])
      ]),
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              key: "name",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.name), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "devicenumber",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.devicenumber), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "starttimestring",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.starttimestring), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "numberoftags",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.numberoftags), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            (props.row.type === 2 || props.row.type === 5)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: "debuglevel",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_select, {
                      dense: "",
                      outlined: "",
                      "emit-value": "",
                      "map-options": "",
                      options: _ctx.debugLevels,
                      modelValue: props.row.debuglevel,
                      "onUpdate:modelValue": [($event: any) => ((props.row.debuglevel) = $event), ($event: any) => (_ctx.onDebugLevelChange(props.row))],
                      style: {"min-width":"80px"},
                      class: "q-pa-none"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["props"]))
              : _createCommentVNode("", true),
            (props.row.type === 2 || props.row.type === 5)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: "actions",
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      dense: "",
                      flat: "",
                      icon: "download",
                      color: "primary",
                      onClick: ($event: any) => (_ctx.downloadLog(props.row.devicenumber))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["props"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["rows", "columns", "rows-per-page-label"])
  ]))
}